import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from '../src/AuthContext';
import { db } from '../src/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';


const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    const fetchCart = async () => {
      if (user) {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
  
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCartItems(userData.shoppingCart || []);
        }
      }
    };
  
    fetchCart();
  }, [user]);

  const addToCart = (product) => {
    setCartItems((prevItems) => {
      const updatedCart = [...prevItems, product];
    
      if (user) {
        const userDocRef = doc(db, 'users', user.uid);
        updateDoc(userDocRef, {
          shoppingCart: updatedCart
        }).catch((error) => {
          console.error("Error actualizando el carrito en Firestore:", error);
        });
      }

      return updatedCart;
    });
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, setCartItems }}>
      {children}
    </CartContext.Provider>
  );
};
